import React, { useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import MaskedTextInput from 'react-text-mask';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale } from 'react-datepicker';
import { ru } from 'date-fns/esm/locale';
import styles from './datepicker.module.css';

// icons
import calendar from '../../../brand/generated/input/calendar.svg';

import { textStyles } from '../../../constants/textStyles';
import { colors } from '../../../constants/colors';
import dayjs from 'dayjs';

registerLocale('ru', ru);

const Datepicker = ({ label, onChange, placeholder, value, defaultValue, disabled, required, isClearable }) => {
  const [startDate, setStartDate] = useState(() => {
    if (!defaultValue) return null;
    const d = new Date(defaultValue);
    return Number.isNaN(d.getTime()) ? null : d;
  });

  // ÐÐ°ÑÑ Ð¿Ð¾Ð»Ðµ Ð´ÐµÑÐ¶Ð¸Ñ Ð² ÑÐ²Ð¾ÑÐ¼ state, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ ÑÐ½Ð°ÑÑÐ¶Ð¸ ÐµÑ Ð±ÑÐ»Ð¾ Ð½Ðµ ÑÐ±ÑÐ¾ÑÐ¸ÑÑ: ÑÐ¸ÑÑÐ¸ÑÑ
  // Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð² ÑÐ¾ÑÐ¼Ðµ (ÐºÑÐµÑÑÐ¸Ðº Ð½Ð° Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐ½Ð½Ð¾Ð¼ ÑÐ¸Ð»ÑÑÑÐµ) â Ð² Ð¿Ð¾Ð»Ðµ Ð¿Ð¾-Ð¿ÑÐµÐ¶Ð½ÐµÐ¼Ñ Ð´Ð°ÑÐ°.
  // Ð¡Ð¸Ð½ÑÑÐ¾Ð½Ð¸Ð·Ð¸ÑÑÐµÐ¼ ÑÐ¾Ð»ÑÐºÐ¾ Ð¾ÑÐ¸ÑÑÐºÑ: Ð² Ð¾ÑÑÐ°Ð»ÑÐ½Ð¾Ð¼ Ð¿Ð¾Ð»Ðµ Ð¾ÑÑÐ°ÑÑÑÑ Ð½ÐµÑÐ¿ÑÐ°Ð²Ð»ÑÐµÐ¼ÑÐ¼.
  React.useEffect(() => {
    if (value === null || value === undefined || value === '') setStartDate(null);
  }, [value]);

  return (
    <div className={styles.input}>
      <label style={textStyles.fieldLabel}>{label} {required && <span style={{ color: colors.red }}>*</span>}</label>
      <ReactDatePicker
        customInput={<MaskedTextInput placeholder='ÐÐ.ÐÐ.ÐÐÐÐ' type="text" mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]} />}
        locale={'ru'}
        dateFormat="dd.MM.yyyy"
        selected={startDate}
        isClearable={isClearable}
        shouldCloseOnSelect={true}
        onChange={(date) => {
          if (!date) {
            setStartDate(null);
            onChange(null);
            return;
          }

          const next = dayjs(date).hour(12).toDate();
          setStartDate(next);
          onChange(next);
        }}
        placeholderText={placeholder}
        disabled={disabled}
      />
      <img src={calendar} alt="Icon" />
    </div>
  );
};

export default Datepicker;
